import { IOption } from 'common/models/commonModel';

// export function queryToObject<State extends {}>(keysOfProps: State): {} {
//   const location = window.location;

//   if (!location) {
//     return {};
//   }

//   const acc: { [index: string]: any } = {};
//   // @ts-ignore
//   for (const [key, value] of new window.URL(location).searchParams) {
//     const clearedKey = key.replace('[]', '');
//     const isValArray = key !== clearedKey;
//     const keyOfPropsArray = Object.keys(keysOfProps);

//     if (keyOfPropsArray.includes(clearedKey)) {
//       let val = value;
//       try {
//         val = JSON.parse(value);
//         // eslint-disable-next-line no-empty
//       } catch (e) {}

//       if (isValArray) {
//         if (!acc[clearedKey]) {
//           acc[clearedKey] = [val];
//         }
//         const exist = acc[clearedKey].find((el: any) => el.id === val.id);
//         if (!exist) {
//           acc[clearedKey].push(val);
//         }
//       } else {
//         acc[clearedKey] = val;
//       }
//     }
//   }
//   return acc;
// }

export function queryToObject<State extends Record<string, any>>(keysOfProps: State): Partial<State> {
  const location = window.location;
  if (!location) {
    return {};
  }

  const acc: Partial<State> = {};
  const searchParams = new URL(location.href).searchParams;

  for (const [key, value] of searchParams.entries()) {
    const clearedKey = key.replace('[]', '') as keyof State;
    const isArray = key !== clearedKey;

    if (!(clearedKey in keysOfProps)) {
      continue;
    }

    let val: any = value;
    try {
      val = JSON.parse(value);
      // eslint-disable-next-line no-empty
    } catch (e) { }

    if (isArray) {
      if (!acc[clearedKey]) {
        acc[clearedKey] = [] as any;
      }

      (acc[clearedKey] as any[]).push(val);
    } else {
      acc[clearedKey] = val;
    }
  }

  return acc;
}

export function objectToQuery(obj: { [index: string]: any; } = {}): string {
  return obj && typeof obj === 'object'
    ? `?${Object.keys(obj)
      .filter((k: any) => obj[k] !== undefined)
      .map((k) =>
        Array.isArray(obj[k])
          ? obj[k]
            .filter((item: any) => item !== undefined)
            .map(
              (item: any) =>
                `${encodeURIComponent(k)}[]=${typeof item === 'object' ? encodeURIComponent(JSON.stringify(item)) : encodeURIComponent(item)
                }`
            )
            .join('&')
          : `${encodeURIComponent(k)}=${typeof obj[k] === 'object' ? encodeURIComponent(JSON.stringify(obj[k])) : encodeURIComponent(obj[k])
          }`
      )
      .join('&')}`
    : !obj
      ? ''
      : obj;
}

export const filterSelectorOptions = (options: IOption[], search: string) => {
  return options.filter((item) => (item.label as string)?.toLowerCase().includes(search.toLowerCase()));
};
